<template>
  <AdminForm
    :config="config"
    :form="form"
    :isBusy="isBusy"
    :options="options"
    @submit:create:success="postFile"
    @submit:update:success="postFile"
  ></AdminForm>
</template>

<script>
import AdminForm from "@/components/Global/AdminForm";
import config from "./config";

export default {
  name: "ComplaintForm",
  components: {
    AdminForm,
  },
  props: ["id_to_edit"],
  data() {
    return {
      config: config,
      form: {
        renting_id: null,
        business_return_id: null,
        transfer_id: null,
        reference_id: null,
        status_slug: null,
        stored_files: [],
      },
      isBusy: false,
      initialForm: {},
    };
  },
  computed: {
    options: function () {
      return {
        renting_id_options: this.$store.getters["renting/getAll"].selectOptions(
          "id",
          "renting_number"
        ),
        business_return_id_options: this.$store.getters["business_return/getAll"].selectOptions(
          "id",
          "return_number"
        ),
        transfer_id_options: this.$store.getters["transfer/getAll"].selectOptions(
          "id",
          "transfer_number"
        ),
        complaint_type_slug_options: this.$store.getters[config.storeNamespace + "/getTypes"],
        reference_id_options: this.$store.getters["reference/getAll"].selectOptions("id", [
          "product.name",
          " - ",
          "internal_code",
        ]),
        status_slug_options: this.$store.getters["status/getByGroup"]("complaint").selectOptions(
          "status_slug",
          "name"
        ),
      };
    },
  },
  mounted() {
    // Edition
    const id =
      this.$route.name == config.editRouteName && this.$route.params.id
        ? this.$route.params.id
        : this.id_to_edit || null;

    if (id) {
      this.isBusy = true;
      this.$store
        .dispatch(config.storeNamespace + "/getItem", {
          id: id,
          wait: true,
        })
        .then(() => {
          let item = _.cloneDeep(this.$store.getters[config.storeNamespace + "/getItem"](id));
          this.form = {
            ...item,
            renting_id: item.renting ? item.renting.id : null,
            business_return_id: item.business_return ? item.business_return.id : null,
            transfer_id: item.transfer ? item.transfer.id : null,
            reference_id: item.reference ? item.reference.id : null,
            status_slug: item.status ? item.status.status_slug : null,
          };
          // On sauvegarde les données initiales, donc avant modification dans le form, pour ensuite
          // les utiliser dans la gestion des fichiers joints
          this.initialForm = _.cloneDeep(this.form);
          this.isBusy = false;
        });
    }

    this.$store.dispatch("renting/getAllForSelect");
    this.$store.dispatch("business_return/getAllForSelect");
    this.$store.dispatch("transfer/getAllForSelect");
    this.$store.dispatch("reference/getAllForSelect");
  },
  methods: {
    postFile(response) {
      // Si il ya des fichiers
      if (this.form.stored_files) {
        this.form.stored_files.forEach((fileLine) => {
          // Si il ne s'agit pas d'un fichier déjà présent
          if (!fileLine.id) {
            let item = {
              complaint_id: response.data.object.id,
              type_slug: "complaint-attachment",
              format: fileLine.file.type,
              file: fileLine.file,
            };

            this.$store.dispatch("stored_file/addItem", item);
          }
        });

        // Gestion des fichiers supprimés
        // On compare les données du formulaire avant modification avec mes données modifiées
        // pour identifier les fichiers supprimés
        if (this.initialForm.stored_files) {
          this.initialForm.stored_files.forEach((fileLine) => {
            // Si le fichiers courant n'est plus dans les fichiers du formulaire, c'est qu'il faut le supprimer
            if (!this.form.stored_files.find((item) => item.id == fileLine.id)) {
              this.$store.dispatch("stored_file/deleteItem", fileLine.id);
            }
          });
        }
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Complaint/ComplaintForm.vue